var _g, _path, _path2, _g2, _path3, _path4, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDisappointedEmoji = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 89,
  height: 88,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#ffd95a",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M29.5 0h30v88h-30z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.5 6h52v76h-52z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.5 12h64v64h-64z"
}))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#ffd95a",
  d: "M6.5 18h76v52h-76z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffd95a",
  d: "M.5 30h88v28H.5z"
})), /*#__PURE__*/React.createElement("g", {
  fill: "#ffd95a",
  opacity: 0.6,
  style: {
    mixBlendMode: "multiply"
  }
}, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M29.5 0h30v88h-30z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.5 6h52v76h-52z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.5 12h64v64h-64z"
}))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M6.5 18h76v52h-76z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M.5 30h88v28H.5z"
}))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
  fill: "#2d2d2d"
}, /*#__PURE__*/React.createElement("path", {
  d: "M41.5 59h6v6h-6z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M41.5 59h6v6h-6zM47.5 59h6v6h-6zM53.5 65h6v6h-6zm-24 0h6v6h-6zM35.5 59h6v6h-6zm-17-12h6v6h-6zm46 0h6v6h-6zM24.5 41h12v6h-12zm28 0h12v6h-12z"
}))));
export default SvgDisappointedEmoji;